export default [
  {
    path: '/bind-account/app-bind-account',
    name: 'bind-account',
    meta: {
      index: 1
    },
    component: () => import(/* webpackChunkName: "bind-account" */ '../../pages/bind-account/app-bind-account.vue')
  }
]
